<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Add Solution</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn"><i class="fa-regular fa-xmark"></i>
      </button>
    </mat-dialog-actions>

  </div>

  <mat-dialog-content class="full-grow-no-shrink-no-basis">
    <form class="flex flex-col full-grow-no-shrink-no-basis" [formGroup]="addSolutionForm">
      <div class="flex flex-col flex-1-0-auto ">

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Select Product</mat-label>
            <mat-select (selectionChange)="onSelectionChange()" formControlName="productCode" required>
              <mat-option *ngFor="let product of data.products" [value]="product.productCode">
                {{ product.productName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" floatLabel="always" floatPlaceholder="always">
            <mat-label>Select Solution *</mat-label>
            <input analyticsAction="select-solution" analyticsCategory="add-solution" matInput
                   particleAnalytics formControlName="solutions"
                   placeholder="Input"
                   style="display: none">

            <div class="flex flex-col" [ngStyle]="fieldStyle" style="max-height: 300px;overflow: auto">
              <ng-container *ngFor="let item of data.solutions; let i=index">
                <mat-checkbox (change)="onCheckboxChange($event)"
                              [value]="item" class="">
                  {{item.solutionName}}
                </mat-checkbox>
              </ng-container>
            </div>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-checkbox formControlName="isActive">Is Active</mat-checkbox>
        </div>

        <div class="m-t-10 flex flex-row justify-start items-center auto-flex">
          <mat-form-field appearance="outline" class="orbitax-date-picker flex-1-1-35" 
                          particleAnalytics
                          analyticsCategory="add-solution"
                          analyticsAction="expiry-date">
            <mat-label>Expiry Date:</mat-label>
            <input matInput [value]="addSolutionForm.value.expiryDate" (dateChange)="onDatePickerChange($event)"
                   [matDatepicker]="picker">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <button mat-button class="m-l-20  orbitax-footer-button" style="position: relative;top: -8px"
                  (click)="onClickAddOneYear()">+1 Year
          </button>
        </div>

      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="mat-flat-button orbitax-footer-button mat-button" [mat-dialog-close]="result">Cancel
    </button>
    <button mat-button (click)="onSave()" [mat-dialog-close]="result" mat-flat-button
            class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
            [disabled]="!addSolutionForm.valid" cdkFocusInitial>Save
    </button>
  </mat-dialog-actions>
</div>
